import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { Bluetooth, Image as ImageIcon, MessageCircle, User } from 'lucide-react'
import { useMemo } from 'react'

const NAV_ITEMS = [
  { id: 'devices', to: '/app/devices', label: 'Devices', icon: Bluetooth },
  { id: 'gallery', to: '/app/gallery', label: 'Gallery', icon: ImageIcon },
  { id: 'ai', to: '/app/ai', label: 'AI', icon: MessageCircle },
  { id: 'mine', to: '/app/mine', label: 'Mine', icon: User },
]

function pickTitle(pathname) {
  const p = String(pathname || '')
  if (p.startsWith('/app/devices')) return 'Devices'
  if (p.startsWith('/app/gallery')) return 'Gallery'
  if (p.startsWith('/app/mine')) return 'Mine'
  return 'AI'
}

export default function AppPreviewLayout() {
  const location = useLocation()
  const title = useMemo(() => pickTitle(location.pathname), [location.pathname])

  return (
    <div className="chamii-viewport bg-brand-bg dark:bg-slate-950 text-brand-textDark dark:text-slate-100">
      <div className="max-w-md mx-auto chamii-viewport flex flex-col">
        <header className="chamii-safe-top sticky top-0 z-[80] bg-brand-bg/85 dark:bg-slate-950/75 backdrop-blur border-b border-black/5 dark:border-white/10">
          <div className="px-4 pt-4 pb-3 flex items-center justify-between">
            <div className="min-w-0">
              <div className="text-lg font-black tracking-tight truncate">{title}</div>
              <div className="text-xs font-bold text-brand-text/70 dark:text-slate-300/70 truncate">Web Preview</div>
            </div>
            <div className="flex items-center gap-2" />
          </div>
        </header>

        <main className="flex-1 px-4 py-4 pb-[calc(96px+env(safe-area-inset-bottom))]">
          <Outlet />
        </main>

        <div className="fixed bottom-0 left-0 right-0 z-[80]">
          <div className="max-w-md mx-auto px-4 pb-[max(12px,env(safe-area-inset-bottom))]">
            <div className="relative">
              <div className="absolute left-1/2 -top-3 -translate-x-1/2 px-2 py-1 rounded-full text-[10px] font-black tracking-widest bg-brand-yellow text-brand-textDark border-2 border-brand-textDark shadow-[2px_2px_0px_0px_#E5BC2E] pointer-events-none">
                BETA
              </div>
              <nav className="rounded-3xl border-2 border-brand-textDark bg-white/85 dark:bg-slate-950/80 backdrop-blur shadow-[6px_6px_0px_0px_#CBD5E1] overflow-hidden">
                <div className="grid grid-cols-4">
                  {NAV_ITEMS.map((item) => {
                    const Icon = item.icon
                    return (
                      <NavLink
                        key={item.id}
                        to={item.to}
                        className={({ isActive }) =>
                          `flex flex-col items-center justify-center gap-1 py-3.5 transition-colors ${
                            isActive
                              ? 'bg-brand-yellow text-brand-textDark'
                              : 'text-brand-text/80 dark:text-slate-300/80 hover:bg-black/5 dark:hover:bg-white/5'
                          }`.trim()
                        }
                      >
                        <Icon className="w-5 h-5" strokeWidth={2.6} />
                        <span className="text-[11px] font-extrabold leading-none">{item.label}</span>
                      </NavLink>
                    )
                  })}
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
